import { render, staticRenderFns } from "./mBetRecordView.vue?vue&type=template&id=9cefa68a&scoped=true"
import script from "./mBetRecordView.vue?vue&type=script&lang=js"
export * from "./mBetRecordView.vue?vue&type=script&lang=js"
import style0 from "./mBetRecordView.vue?vue&type=style&index=0&id=9cefa68a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cefa68a",
  null
  
)

export default component.exports